<template>
    <div class="chat_lobby">        
        <div class="main_room">
            <chat-header :usercount="users.length" @updatesetting="updatesetting"/>
            <div class="chat_body">                
                <chat-body
                :messages="messages"
                :admin_messages="admin_messages"
                :isChat="isChat"
                :ownerId ="owner_userId"
                :chat_roomId="chat_roomId"
                :ckstate="setstate"                
                @sendmessage="sendMessage"
                @initstate="initstate"
                @disconnect ="disconnect"
                />
            </div>             
        </div>
        <div v-if='view_chat_rooms' @click="open_roomList()" class="backdrop"></div>
        <div class="chat_rooms" id="chat_rooms">
            <div  class="title" @click="open_roomList()">
                <div>
                    <font-awesome-icon icon="angle-up"  v-if="!view_chat_rooms"/>
                    <font-awesome-icon icon="angle-down"   v-else/>
                </div>
                <div>
                    채팅방 목록
                </div>
                <div>
                    <font-awesome-icon icon="angle-up"  v-if="!view_chat_rooms"/>
                    <font-awesome-icon icon="angle-down"   v-else/>
                </div>               
            </div>
            <div class="make_room" >
                <span @click="open_makeroom()" :class="{btn_disable:itemck}">
                   {{createRoom_txt}}                   
                </span>
            </div>
            <div class="room_list">
                <chat-room-list :isMobile="true" :newChatRoom="newChatRoom"/>
            </div>           
        </div>
        <base-dialog :show="pop_makeroom" @close="open_makeroom" :isMobile="true" title="채팅방 개설" :fixed="true">            
            <chatroom-create @cancel="open_makeroom()" @createroom="create_room"/>
        </base-dialog>
    </div>
</template>
<script>
import ChatHeader from "@/components/chat/parts/ChatHeader";
import ChatBody from "@/mobile/components/chat/parts/ChatBody";
import { socketio } from '@/components/mixins/socketio.js';
import ChatRoomList from '@/components/chat/ChatRoomList';
import ChatroomCreate from '@/mobile/pages/chat/ChatroomCreate'
import { auth } from '@/components/mixins/auth.js';
export default {
    name:'mobile_chatLobby',
    props:[
        
    ],
    data(){
        return{
            chat_roomId:'m1',
            view_chat_rooms:false,
            pop_makeroom:false,
            itemck:false,
        }
    },
    mixins:[
        auth,socketio
    ],
    components:{
        ChatBody,
        ChatRoomList,
        ChatHeader,
        ChatroomCreate
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated;
        },    
        createRoom_txt(){
             if (this.itemck) {
                return "아이템확인 중";
            } else {
                return '채팅방 개설';
            }            
        }        
    },
    mounted() {
        this.currentUser = this.$store.getters.currentUser;
        this.userIP = this.$store.getters.userIP;
    },
    methods:{
        joinMainChat(){
            this.$router.push('/m_chat')
        },
        open_roomList(){
            document.querySelector('#chat_rooms').classList.toggle('view_chat_rooms'); 
            this.view_chat_rooms = !this.view_chat_rooms;
        },
        async open_makeroom(){
            if(this.itemck)
            {
                return;
            }
            if(!this.isLoggedIn)
            {
                if(confirm('로그인이 필요 합니다.'))
                {
                    this.$router.push({ name: 'm_Login', params: { prevroute: 'm_ChatLobby' }})
                }
                //alert(this.$route.name);
                //this.socket.disconnect();
               
            }else{
                //아이템 유무 판단
                this.itemck = true;
                const ckitem =  await this.ckItem('chat_makeroom','pop','','','isMobile');

                this.itemck = false;
                if(!ckitem){
                    return;
                }
                
                //this.socket.disconnect();
                //this.$router.push('/chat/create');
                this.pop_makeroom = !this.pop_makeroom;
            }
            
        },
        create_room(room_id)
        {
            this.$router.push('/m_chat/'+ room_id);  
            this.open_makeroom();
        }

    }
}
</script>
<style lang="scss" scoped>
.chat_lobby{
    flex:1 1 auto;
    display: flex;
    flex-direction: column;
    background: #fff;
    .main_room{            
        height:calc( 100vh - 250px );
        .chat_body{
            height:calc( 100vh - 320px );   
        }       
    }
    .chat_rooms{
        background:rgb(13, 90, 121);
        height: 100vh;
        width:100%;
        position: fixed;
        right:0px;
        top:0px;
        background:#fff;  
        transform: translateY(calc( 100vh - 200px ));
        transition: transform 0.3s ease-in 0s;
        display: flex;
        flex-direction: column;   
        z-index: 10;       
        .title{
            margin-top:10px;
            text-align: center;
            font-size:16px;
            font-weight:bold;
            padding:10px 20px;
            display: flex;
            justify-content: space-between;
            
        }
        .make_room{
            text-align: center;
            padding:10px 10px 20px 10px;
            span{
                display: inline-block;
                background: rgb(29, 97, 223);
                line-height: 30px;                          
                border-radius: 10px;
                width:100%;
                color:#fff;                 
            }  
            .btn_disable{
                background: #ccc !important;
                color:rgb(90, 90, 90);      
            }          
        }
        
    }
    .view_chat_rooms{
        transform: translateY(calc( 100vh - 550px )); 
        transition: transform 0.2s ease-in 0s;   
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
}
</style>